import api from './api';

const basePath = '/api/admin/library-appointments';

export const fetchLibraryAppointments = async ({
  startDate,
  endDate,
  search,
  status,
  slotStartTime,
  page = 1,
  pageSize = 20,
} = {}) => {
  const params = {
    page,
    pageSize,
  };

  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (search) params.q = search;
  if (status) params.status = status;
  if (slotStartTime) params.slotStartTime = slotStartTime;

  return api.get(basePath, { params });
};

export const updateLibraryAppointment = async (id, payload) =>
  api.put(`${basePath}/${id}`, payload);

export const deleteLibraryAppointment = async (id, hardDelete = false) =>
  api.delete(`${basePath}/${id}`, {
    params: { hardDelete },
  });

export const getLibraryAppointmentSettings = async () =>
  api.get(`${basePath}/settings`);

export const updateLibraryAppointmentSettings = async (payload) =>
  api.put(`${basePath}/settings`, payload);

export const staffConfirmLibraryAppointment = async ({ appointmentId, appointmentCode }) =>
  api.post(`${basePath}/staff-confirm`, { appointmentId, appointmentCode });

const searchAppointmentByCode = async (appointmentCode) => {
  if (!appointmentCode) {
    return {
      isSuccess: false,
      resultMessage: 'Geçerli bir randevu kodu bulunamadı.',
    };
  }

  try {
    const searchResult = await api.get(basePath, {
      params: {
        q: appointmentCode,
        page: 1,
        pageSize: 1,
      },
    });

    if (
      searchResult?.isSuccess &&
      (searchResult.data?.items?.length || searchResult.data?.Items?.length)
    ) {
      const items = searchResult.data.items || searchResult.data.Items || [];
      return {
        isSuccess: true,
        data: items[0],
        resultMessage: '',
      };
    }

    return {
      isSuccess: false,
      resultMessage:
        searchResult?.resultMessage ||
        'Randevu bilgileri getirilemedi. Lütfen kodu kontrol edin.',
    };
  } catch (error) {
    return {
      isSuccess: false,
      resultMessage: error?.message || 'Randevu bilgileri getirilemedi.',
    };
  }
};

export const previewLibraryAppointmentForStaff = async ({ appointmentId, appointmentCode }) => {
  if (!appointmentId && appointmentCode) {
    return searchAppointmentByCode(appointmentCode);
  }

  try {
    return await api.get(`${basePath}/staff-preview`, {
      params: { appointmentId, appointmentCode },
    });
  } catch (error) {
    if (error?.response?.status === 405) {
      return searchAppointmentByCode(appointmentCode);
    }
    throw error;
  }
};

export const createLibraryAppointment = async (payload) =>
  api.post(basePath, payload);

